import React from 'react';
import UltraPackListItem from './UltraPackListItem';
import styles from '../AssetSizes/AssetSizes.module.scss';
import useSelectedIndex from '../../../hooks/stateful/useSelectedIndex.ts';

const UltraPacks = () => {
  const { selectedSize } = useSelectedIndex();

  if (
    !selectedSize ||
    !selectedSize.imagePackSavings ||
    selectedSize.imagePackSavings.length === 0
  ) {
    return null;
  }

  return (
    <div
      className={styles.table}
      data-testid="ultra-pack-list"
    >
      {selectedSize.imagePackSavings.map((imagePack) => (
        <UltraPackListItem
          key={imagePack.packSize}
          pack={imagePack}
          currencyCode={selectedSize.currencyCode}
        />
      ))}
    </div>
  );
};

export default UltraPacks;
